import React, { useState, useEffect, useRef } from 'react';
import './sub1.css'; 
import { FaArrowRight, FaArrowLeft } from "react-icons/fa";

const CityLocation = ({ cities }) => {
  const [currentPage, setCurrentPage] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const scrollContainerRef = useRef(null);
  
  const CITIES_PER_PAGE_MOBILE = 1; // 1 city per page in mobile
  const CITIES_PER_PAGE_DESKTOP = 4;
  
  // Detect mobile screen size
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    
    return () => {
      window.removeEventListener('resize', checkScreenSize);
    };
  }, []);
  
  // Calculate total pages
  const totalPages = isMobile 
    ? Math.ceil(cities.length / CITIES_PER_PAGE_MOBILE)
    : Math.ceil(cities.length / CITIES_PER_PAGE_DESKTOP);
  
  // Get current page cities
  const getCurrentPageCities = () => {
    if (isMobile) {
      const startIndex = currentPage * CITIES_PER_PAGE_MOBILE;
      return cities.slice(startIndex, startIndex + CITIES_PER_PAGE_MOBILE);
    } else {
      const startIndex = currentPage * CITIES_PER_PAGE_DESKTOP;
      return cities.slice(startIndex, startIndex + CITIES_PER_PAGE_DESKTOP);
    }
  };
  
  // Handle scroll for mobile
  const handleScroll = () => {
    if (!scrollContainerRef.current || !isMobile) return;
    
    const scrollLeft = scrollContainerRef.current.scrollLeft;
    const cardWidth = scrollContainerRef.current.offsetWidth;
    const newPage = Math.round(scrollLeft / cardWidth);
    setCurrentPage(newPage);
  };
  
  // Go to specific page
  const goToPage = (pageIndex) => {
    setCurrentPage(pageIndex);
    
    if (isMobile && scrollContainerRef.current) {
      const containerWidth = scrollContainerRef.current.offsetWidth;
      scrollContainerRef.current.scrollTo({
        left: pageIndex * containerWidth,
        behavior: 'smooth'
      });
    }
  };
  
  // Next page
  const nextPage = () => {
    if (currentPage < totalPages - 1) {
      goToPage(currentPage + 1);
    }
  };
  
  // Previous page
  const prevPage = () => {
    if (currentPage > 0) {
      goToPage(currentPage - 1);
    }
  };

  return (
    <section className="city-location">
      <h2>City Location</h2>
      
      {/* Desktop View - Grid Layout */}
      {!isMobile && (
        <div className="city-list">
          {getCurrentPageCities().map((city, index) => (
            <div className="city-card" key={index}>
              <img src={city.image} alt={city.name} />
              <h3>{city.name}</h3>
              <p>{city.contact}</p>
            </div>
          ))}
        </div>
      )}
      
      {/* Mobile View - Horizontal Slider with 1 City */}
      {isMobile && (
        <>
          <div className="mobile-slider-container">
            <button 
              className="arrow-btn left-arrow" 
              onClick={prevPage}
              disabled={currentPage === 0}
            >
             <FaArrowLeft />
            </button>
            
            <div 
              className="city-scroll-container"
              ref={scrollContainerRef}
              onScroll={handleScroll}
            >
              <div className="city-scroll-content">
                {cities.map((city, index) => (
                  <div className="city-card mobile-card" key={index}>
                    <img src={city.image} alt={city.name} />
                    <h3>{city.name}</h3>
                    <p>{city.contact}</p>
                  </div>
                ))}
              </div>
            </div>
            
            <button 
              className="arrow-btn right-arrow" 
              onClick={nextPage}
              disabled={currentPage === totalPages - 1}
            >
              <FaArrowRight />
            </button>
          </div>
        </>
      )}
      
      {/* Dot Pagination */}
      {totalPages > 1 && (
        <div className="dot-pagination">
          {Array.from({ length: totalPages }).map((_, index) => (
            <button
              key={index}
              className={`dot ${currentPage === index ? 'active' : ''}`}
              onClick={() => goToPage(index)}
              aria-label={`Go to page ${index + 1}`}
            />
          ))}
        </div>
      )}
    </section>
  );
};

export default CityLocation;